export default {
  BASE_URL: window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"
    ? "http://localhost:5051"
    : (process.env.REACT_APP_BACKEND_URL || "https://api.texpidea.com/api")
};